<template>
  <div class="vch-rating">
    <div class="vch-rating__list">
      <div class="vch-rating__star">
        <svg
          v-for="(index, key) in maxRating"
          :key="key"
          aria-hidden="true"
          height="28"
          width="28"
          viewBox="0 0 28 30"
          class="vch-rating__star--white"
          step="100"
        >
          <polygon
            points="12.727272727272727,1.4141414141414141,4.242424242424242,28,25.454545454545453,11.03030303030303,0,11.03030303030303,21.21212121212121,28"
            fill="white"
            stroke="#000"
            stroke-width="2"
            stroke-linejoin="miter"
          ></polygon>
          <polygon
            points="12.727272727272727,1.4141414141414141,4.242424242424242,28,25.454545454545453,11.03030303030303,0,11.03030303030303,21.21212121212121,28"
            fill="white"
          ></polygon>
        </svg>
        <div
          class="overlay-stars"
          :style="{ width: fillStars(rating.average) }"
        >
          <svg
            v-for="index in maxRating"
            :key="index.average"
            aria-hidden="true"
            height="28"
            width="28"
            viewBox="0 0 28 30"
            class="vch-rating__star--black"
            step="100"
          >
            <polygon
              points="12.727272727272727,1.4141414141414141,4.242424242424242,28,25.454545454545453,11.03030303030303,0,11.03030303030303,21.21212121212121,28"
              fill="white"
              stroke="#000"
              stroke-width="2"
              stroke-linejoin="miter"
            ></polygon>
            <polygon
              points="12.727272727272727,1.4141414141414141,4.242424242424242,28,25.454545454545453,11.03030303030303,0,11.03030303030303,21.21212121212121,28"
              fill="black"
            ></polygon>
          </svg>
        </div>
      </div>
    </div>
    <span class="sr-only">
      rating:
      {{ rating.average }} out of {{ maxRating }}
    </span>
    <span class="vch-rating__text heading-xxs">{{ rating.label }}</span>
  </div>
</template>

<script>
export default {
  name: 'vch-product-card-rating',
  props: {
    rating: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxRating: 5,
    };
  },

  methods: {
    fillStars(average) {
      const convertedAverage = parseFloat(average.replace(',', '.'));
      const starPercentage =
        (parseFloat(convertedAverage) / this.maxRating) * 100;
      return parseFloat(convertedAverage) > 0 ? `${starPercentage}%` : '0%';
    },
  },
};
</script>
